import { useMutation, useQuery } from "react-query";
import { Auth } from "shared/@auth/Auth";

export function useIncident(incidentNo) {
  const { makeAuthedRequest } = Auth.useContainer();

  const {
    data: incidentData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery(
    // Query Key for invalidating data
    ["incident"],
    () =>
      makeAuthedRequest(`/incidents/${incidentNo}`, {
        method: "GET",
      }).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),
    { staleTime: 0 }
  );

  const incidentNotePost = useMutation((noteObj) =>
    makeAuthedRequest(`/incidents/note`, {
      method: "POST",
      body: JSON.stringify(noteObj),
    }).then(async (res) => {
      if (res.ok) {
        return;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const incidentCommunicationPost = useMutation((comObj) =>
    makeAuthedRequest(`/incidents/communication-email`, {
      method: "POST",
      body: JSON.stringify(comObj),
    }).then(async (res) => {
      if (res.ok) {
        return;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const incidentEscalatePut = useMutation((escalateObj) =>
    makeAuthedRequest(`/incidents/escalate`, {
      method: "PUT",
      body: JSON.stringify(escalateObj),
    }).then(async (res) => {
      if (res.ok) {
        return;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const incidentEditPut = useMutation((incidentEditObj) =>
    makeAuthedRequest(`/incidents/caseinfo`, {
      method: "PUT",
      body: JSON.stringify(incidentEditObj),
    }).then(async (res) => {
      if (res.ok) {
        return;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const incidentReminderPut = useMutation((incidentReminderObj) =>
    makeAuthedRequest(`/incidents/add-reminder`, {
      method: "PUT",
      body: JSON.stringify(incidentReminderObj),
    }).then(async (res) => {
      if (res.ok) {
        return;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const incidentDocumentationPut = useMutation((incidentDocumentationObj) =>
    makeAuthedRequest(`/incidents/documentation`, {
      method: "PUT",
      body: JSON.stringify(incidentDocumentationObj),
    }).then(async (res) => {
      if (res.ok) {
        return;
      } else {
        const body = await res.json();
      }
    })
  );

  // get file type from arrayBuffer data
  const getMimeTypeFromArrayBuffer = (arrayBuffer) => {
    const uint8arr = new Uint8Array(arrayBuffer);

    const len = 4;
    if (uint8arr.length >= len) {
      let signatureArr = new Array(len);
      for (let i = 0; i < len; i++)
        signatureArr[i] = new Uint8Array(arrayBuffer)[i].toString(16);
      const signature = signatureArr.join("").toUpperCase();

      switch (signature) {
        case "89504E47":
          return "image/png";
        case "47494638":
          return "image/gif";
        case "25504446":
          return "application/pdf";
        case "FFD8FFDB":
        case "FFD8FFE0":
          return "image/jpeg";
        case "504B0304":
          return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        default:
          return null;
      }
    }
    return null;
  };

  const downloadImage = async (downloadPath) => {
    return await makeAuthedRequest(`/shared/downloadfile/${downloadPath}`)
      .then(async (res) => {
        if (res.ok) {
          let data = await res.arrayBuffer();
          return data;
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      })
      .then((data) => {
        const blob = new Blob([data], {
          type: getMimeTypeFromArrayBuffer(data),
        });
        // const url = URL.createObjectURL(blob);
        // window.open(url, "_blank");

        const anchor = document.createElement("a");
        anchor.href = URL.createObjectURL(blob);
        anchor.download = downloadPath;
        anchor.click();
        URL.revokeObjectURL(anchor.href);
        anchor.remove();
      });
  };

  return {
    incidentData,
    incidentNotePost,
    incidentCommunicationPost,
    incidentEscalatePut,
    incidentEditPut,
    incidentReminderPut,
    incidentDocumentationPut,
    isLoading,
    isFetching,
    downloadImage,
    refetch,
  };
}
